module.exports = __webpack_public_path__ + "img/img_39.88f455b4.png";